export const ICONS = {
    GREEN_SHIP: `${process.env.REACT_APP_S3_BASE_URL}/icons/green-ship.png`,
    DISABLED_GREEN_SHIP: `${process.env.REACT_APP_S3_BASE_URL}/icons/disbaled-green-ship.png`,
    GREEN_SHIP_CHECKED: `${process.env.REACT_APP_S3_BASE_URL}/icons/green_ship_checked.png`,
    DISABLED_GREEN_SHIP_CHECKED: `${process.env.REACT_APP_S3_BASE_URL}/icons/disabled_green_ship_checked.png`
}
